import { Component, Inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { USER } from 'src/app/core/user.service';
import { KpiStatsItem } from 'src/app/dashboards/dashboard-shared/kpi/kpi-stats/kpi-stats-item';
import { PilotKpiMetrics } from 'src/app/dashboards/pilot-dashboard/pilot-kpis/components/pilot-kpi-stats/pilot-kpi-metrics';
import { PilotKpiStatsItemFactory } from 'src/app/dashboards/pilot-dashboard/pilot-kpis/components/pilot-kpi-stats/pilot-kpi-stats-item-factory';
import { FlightLogApiHttpClient } from 'src/app/shared/flight-log-api/flight-log-api.service';
import { KpiMetrics } from 'src/app/shared/flight-log-api/kpi/kpi.model';
import { UserViewModel } from 'src/view-models/user-view-model';

@Component({
  selector: 'fl-pilot-kpis',
  template: `
    <ng-container *ngIf="user.isPilot">
      <div *ngIf="lastCalculatedAt$ | async; let lastCalculatedAt" style="padding-left: 10px">
        ** Stats current as of {{ lastCalculatedAt | date: 'MM/dd/yyyy HH:mm a' }}
      </div>
      <fl-pilot-kpi-stats
        *ngIf="user.isPilot"
        [stats]="pilotKpiStats$ | async"
      ></fl-pilot-kpi-stats>
    </ng-container>
  `,
})
export class PilotKpisComponent implements OnInit {
  public pilotKpiStats$: Observable<(KpiStatsItem | undefined)[]>;
  public lastCalculatedAt$: Observable<Date | null>;
  constructor(
    @Inject(USER) public readonly user: UserViewModel,
    private _api: FlightLogApiHttpClient,
  ) {}

  public ngOnInit(): void {
    const stats$ = this._api.getKpiStats(this.user.id);
    this.lastCalculatedAt$ = stats$.pipe(map((metrics) => metrics.asOfDateTime));

    this.pilotKpiStats$ = stats$.pipe(
      map((metrics) =>
        flattenStatsItems(metrics, [
          PilotKpiMetrics.create(PilotKpiMetrics.FaaFlightTime.id, [
            PilotKpiMetrics.FaaFlightTime.kpis.hour24,
            PilotKpiMetrics.FaaFlightTime.kpis.quarter1,
            PilotKpiMetrics.FaaFlightTime.kpis.quarter2,
            PilotKpiMetrics.FaaFlightTime.kpis.year1,
          ]),
          PilotKpiMetrics.create(PilotKpiMetrics.Hnvgo.id, [PilotKpiMetrics.Hnvgo.kpis.month3]),
          PilotKpiMetrics.create(PilotKpiMetrics.DutyTime.id, [
            PilotKpiMetrics.DutyTime.kpis.shift1,
          ]),
          PilotKpiMetrics.create(PilotKpiMetrics.NightLandings.id, [
            PilotKpiMetrics.NightLandings.kpis.day90,
          ]),
          PilotKpiMetrics.create(PilotKpiMetrics.TotalLandings.id, [
            PilotKpiMetrics.TotalLandings.kpis.day90,
          ]),
          PilotKpiMetrics.create(PilotKpiMetrics.DutyRestHours.id, [
            PilotKpiMetrics.DutyRestHours.kpis.shift1,
          ]),
        ]),
      ),
    );
  }
}

function flattenStatsItems(
  srcKpiMetrics: KpiMetrics,
  requiredMetrics: PilotKpiMetrics[],
): (KpiStatsItem | undefined)[] {
  return srcKpiMetrics.metrics
    .filter((srcMetric) => requiredMetrics.find((m) => m.id === srcMetric.id) != null)
    .map((srcMetric) =>
      srcMetric.kpis
        .filter((k) =>
          // tslint:disable-next-line: no-non-null-assertion
          requiredMetrics
            .find((m) => m.id === srcMetric.id)!
            .kpis.find((i) => i.granularity === k.granularity && i.windowSize === k.windowSize),
        )
        .map((kpi) => PilotKpiStatsItemFactory.create(srcMetric, kpi.granularity, kpi.windowSize)),
    )
    .reduce((a1, a2) => a1.concat(a2)); // flattens KpiStatsItem[][]
}
